import {Component, ViewChild, OnInit} from '@angular/core';
import {MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
import {SelectionModel} from '@angular/cdk/collections';
import * as XLSX from 'xlsx';
import { Router } from '@angular/router';
import * as firebase from 'firebase';
@Component({
  selector: 'app-adminempresas',
  templateUrl: './adminempresas.component.html',
  styleUrls: ['./adminempresas.component.scss']
})
export class AdminempresasComponent implements OnInit {

  user;
  userId = '';
  ampa;

  // datos de la tabla
  displayedColumns = ['select','imagen', 'nombre',  'telefono',  'email', 'url', 'acciones'];


  selection = new SelectionModel<EmpresasData>(true, []);
  dataSource: MatTableDataSource<EmpresasData>;
  empresas: EmpresasData[] = [];
  initialSelection = [];
  allowMultiSelect = true;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor( private router: Router ) {
    console.log('constructor')
  }

   ngOnInit() {

     console.log('ngoninit')
     this.dataSource = new MatTableDataSource(this.empresas);
     this.dataSource.paginator = this.paginator;
     this.dataSource.sort = this.sort;
     //obtener datos del usuario admin logueado
     this.userId = localStorage.getItem('userId');
     console.log('UserId', this.userId);
     if(!this.userId){
       this.router.navigate[('')]
     } else {
       firebase.firestore().collection('admins').doc(this.userId)
       .get()
       .then((doc)=>{
         this.user = doc.data();
         console.log('User', this.user)

         this.obtenerEmpresas();
       })
     }
  }

  // nos traemos los empresas del ampa utilizando el id de ampa que tiene el usuario en su documento
  obtenerEmpresas(){
    console.log('obtenerEmpresas')
    firebase.firestore().collection('empresas')
    .where('ampa','==', this.user.ampa)
    .get()
    .then((snapshot)=>{

      snapshot.forEach((doc)=>{
        console.log('doc',doc)
        //var elemento: EmpresasData;
        var elemento = doc.data();
        elemento.id = doc.id;
        //hacemos el push
        this.empresas = [...this.empresas, <EmpresasData>elemento];
      })
      this.dataSource = new MatTableDataSource(this.empresas);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    })
  }



  // mostramos los datos del empresa id
  ver(row){
    console.log('Ver ', row.id);
    this.router.navigate(['/admin/empresas/ver/' + row.id]);
  }

  // eliminar empresas seleccionados
  eliminar(){
      this.selection.selected.forEach((empresa) => {
        firebase.firestore().collection('empresas').doc(empresa.id)
        .delete()
        .catch(error => {console.log(error); })
        .then(()=>{
          console.log('Borrada empresa ' + empresa.id)
        })
      });
      this.empresas = [];
      this.obtenerEmpresas();
  }

  // actualizamos los datos de algunos campos del empresa id
  editar(row){
    console.log('Editado ', row.id)
    this.router.navigate(['/admin/empresas/editar/' + row.id])
  }

  //exportamos a xlsx datos de empresas seleccionados
  exportToExcel() {
    var ws = XLSX.utils.json_to_sheet(this.selection.selected);
    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Empresas");
    XLSX.writeFile(wb, 'empresas.xlsx');
  }

  exportToPDF() {

  }


  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected == numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
    this.selection.clear() :
    this.dataSource.data.forEach(row => this.selection.select(row));
  }
}

export interface EmpresasData {
  id: string;
  imagen: string;
  nombre: string;
  direccion: string;
  telefono: string;
  email: string;
  url: string;
  texto_cargo_bancario: string;
  texto_lopd: string;
  texto_cesion_imagenes: string;
  }



// WEBPACK FOOTER //
// ./src/app/adminempresas/adminempresas.component.ts